import { Component, OnInit } from '@angular/core';
import { FinancialSummaryService } from 'src/app/services/financial-summary.service';
import { DataSharedService } from '../../services/data-shared.service';
import * as moment from 'moment';

@Component({
  selector: 'app-financial-summary',
  templateUrl: './financial-summary.component.html',
  styleUrls: ['./financial-summary.component.css']
})
export class FinancialSummaryComponent implements OnInit {

  revenue = 0;
  payout = 0;
  margin = 0;
  marginPercent = 0;
  currencyFormat = '';
  isLoadingSummary = true;
  months: any[] = [];
  selectedMonth: string | null = null;

  constructor(private financialSummaryService: FinancialSummaryService,
    public dataSharedService: DataSharedService,
  ) { }

  ngOnInit(): void {
    const now = moment();
    this.months = this.dataSharedService.getMonths().filter((m: any) => m.value <= now.format('MM'));
    this.selectedMonth = now.format('MM'); // Default to current month
    this.fetchFinancialSummary();
  }

  fetchFinancialSummary() {

    if (!this.selectedMonth) return;

    this.isLoadingSummary = true;
    const year = new Date().getFullYear();
    const month = `${year}-${this.selectedMonth}`

    this.financialSummaryService.getFinancialSummary(month).subscribe(data => {

      this.revenue = data.total_revenue;
      this.payout = data.total_payout;
      this.margin = data.gross_margin;
      this.marginPercent = data.margin_percent;
      this.currencyFormat = data.currency_format;

      this.isLoadingSummary = false;

    });
  }

  onMonthChange() {
    this.fetchFinancialSummary();
  }

}
